import { FileDown } from "lucide-react";
import { PROFILE_PDF_URL } from "@/lib/api";

interface Props {
  className?: string;
  label?: string;
  testId?: string;
}

/** Opens the generated studio-profile PDF (server-rendered from live project data). */
export default function DownloadProfileButton({ className = "btn-ghost", label = "Download studio profile", testId = "download-profile-button" }: Props) {
  return (
    <a
      href={PROFILE_PDF_URL}
      target="_blank"
      rel="noopener noreferrer"
      download="Shriya-Redkar-Interiors-Studio-Profile.pdf"
      data-testid={testId}
      className={className}
    >
      <FileDown className="h-4 w-4" /> {label}
    </a>
  );
}
